export const GET_AUTH = 'GET_AUTH';
export const ADD_AUTH = 'ADD_AUTH';
export const REMOVE_AUTH = 'REMOVE_AUTH';

export const GET_PROFILE = 'GET_PROFILE';
export const SET_PROFILE = 'SET_PROFILE';

export const GET_USER = 'GET_USER';
export const ADD_USER = 'ADD_USER';

export const FETCH_ARTICLE = 'FETCH_ARTICLE';
export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_STAGE = 'FETCH_STAGE';
export const FETCH_ALL_USERS = 'FETCH_ALL_USERS';
